import React, { ComponentProps } from "react";

export default function Ribbon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="65"
      height="61"
      viewBox="0 0 65 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.1006 60.6766C11.6273 60.8103 12.186 60.6719 12.5894 60.3078L22.2988 51.5445L63.9856 13.9196C64.3792 13.5644 64.5782 13.0418 64.5207 12.5148C64.4553 11.9154 64.0683 11.3994 63.5113 11.1686L58.1903 8.96439C57.4365 8.65212 56.8614 8.0196 56.6222 7.23953L54.8967 1.61365C54.7197 1.03658 54.2466 0.59892 53.6575 0.467333C53.1263 0.348676 52.5705 0.494877 52.1665 0.859563L48.7498 3.94329L56.8743 12.9449C57.2309 13.34 57.3971 13.8712 57.3292 14.3991C57.2736 14.8307 57.0655 15.2283 56.7424 15.5199L14.6664 53.4961C14.3395 53.7912 13.9135 53.9522 13.4732 53.9473C12.9844 53.9418 12.5201 53.7323 12.1926 53.3694L4.02008 44.3146L0.805518 47.216C0.391499 47.5896 0.193788 48.1469 0.279703 48.6979C0.36649 49.2546 0.730765 49.7287 1.24626 49.956L6.69156 52.3568C7.4112 52.6741 7.95944 53.2858 8.19629 54.0358L9.95058 59.5907C10.1201 60.1274 10.5551 60.5382 11.1006 60.6766Z"
        fill="#F22522"
      />
      <path
        d="M3.3124 42.6241C3.23835 43.1159 3.38859 43.615 3.72181 43.9842L4.02008 44.3146L12.1926 53.3694C12.5201 53.7323 12.9844 53.9418 13.4732 53.9473C13.9135 53.9522 14.3395 53.7912 14.6664 53.4961L56.7424 15.5199C57.0655 15.2283 57.2736 14.8307 57.3292 14.3991C57.3971 13.8712 57.2309 13.34 56.8743 12.9449L48.7498 3.94329L48.5006 3.66717C48.138 3.26542 47.6086 3.05599 47.0693 3.10094C46.6909 3.13248 46.3333 3.28734 46.0514 3.54174L3.84195 41.6384C3.55674 41.8958 3.3696 42.2442 3.3124 42.6241Z"
        fill="#FF574C"
      />
    </svg>
  );
}
